import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { advertisingReducer } from '@domain/advertising/advertising.state';
import { sideMenuReducer } from '@domain/side-menu/side-menu.state';
import { campaignsReducers } from '@domain/campaigns';
import { partnershipsReducer } from '@domain/partnerships/partnerships.state';
import { comparisonCampaignsReducer } from '@domain/comparison-campaigns';
import { appCatalogReducer } from '@domain/integrations/app-catalog/app-catalog.state';
import { CampaignsInfoReducer } from '@domain/campaigns-info/campaigns-info.state';
import { logRocketReducer } from './domain/analytics/log-rocket/log-rocket.state';
import paretoAdsAppReducer from './domain/_redux/pareto-ads-app-redux/reducer/pareto-ads-app-reducer';

// eslint-disable-next-line import/no-named-default
import { default as legacyCampaignsReducer } from './domain/_redux/campaigns/reducers/main_reducer';
import { omnichannelBudgetManagerReducer } from './domain/omnichannel-budget-manager/omnichannel-budget-manager.state';
import workflowReducers from './domain/_redux/workflow/reducers/workflow_reducer';
import { navigationReducer } from './domain/navigation/navigation.state';
import dashboardReducer from './domain/dashboard/dashboard.state';
import budgetManagerReducer from './domain/budget-manager/budget-manager.state';
import { settingsReducer } from './domain/settings/settings.state';
import headerReducer from './domain/header/header.state';
import { integrationsReducers } from './domain/integrations/integrations.state';
import { platformReducer } from './domain/platform/platform.state';
import { goalsReducers } from './domain/goals/goals.state';
import { alertsReducer } from './domain/alert/alert.state';
import companyReducer from './domain/company/company.state';
import { authReducer } from './domain/auth/auth-state';
import pricingReducer from './domain/pricing/pricing-state';
import { billingReducer } from './domain/billing/billing-state';
import { featureToggleReducer } from './domain/feature-toggle/feature-toggle.state';
import { notificationReducer } from './domain/notification/notification-drawer.state';
import { cardsReducer } from './domain/cards/cards.state';
import { teamMembersReducers } from './domain/team/team.state';
import { teamMembersScreenReducer } from './domain/team/management/team.screen.state';
import { loggedUserReducers } from './domain/logged-user/logged-user.state';
import { userConfigReducer } from './domain/user-config/user-config.state';
import { segmentsReducer } from './domain/segments/segments-main.state';

export default function createReducer(history) {
    return combineReducers({
        advertising: advertisingReducer,
        alerts: alertsReducer,
        auth: authReducer,
        billing: billingReducer,
        budgetManager: budgetManagerReducer,
        campaign: legacyCampaignsReducer,
        campaignsInfo: CampaignsInfoReducer,
        cards: cardsReducer,
        omnichannelBudgetManager: omnichannelBudgetManagerReducer,
        company: companyReducer,
        campaigns: campaignsReducers,
        comparisonCampaigns: comparisonCampaignsReducer,
        dashboard: dashboardReducer,
        data: paretoAdsAppReducer,
        featureToggle: featureToggleReducer,
        goals: goalsReducers,
        header: headerReducer,
        integrations: integrationsReducers,
        appCatalog: appCatalogReducer,
        loggedUser: loggedUserReducers,
        navigation: navigationReducer,
        notifications: notificationReducer,
        partnerships: partnershipsReducer,
        platform: platformReducer,
        pricing: pricingReducer,
        router: connectRouter(history),
        team: teamMembersReducers,
        teamScreen: teamMembersScreenReducer,
        segments: segmentsReducer,
        settings: settingsReducer,
        userConfig: userConfigReducer,
        workflow: workflowReducers,
        logRocket: logRocketReducer,
        sideMenu: sideMenuReducer,
    });
}
